import React from 'react';
import { Card, Typography } from '@one-thd/sui-atomic-components';
import data from './data';
import { ProRewardItem } from './ProRewardItem';

export const ProDeskProRewards = () => {
  return (
    <Card data-component="ProDeskProRewards" PaperProps={{ className: 'sui-size-full' }}>
      <div className="sui-text-left sui-mb-6">
        <Typography variant="h2">PRO REWARDS AND SAVINGS</Typography>
        <Typography>That Keep Building</Typography>
      </div>
      <div
        className={`
          sui-grid 
          sui-place-items-center 
          sui-gap-y-6 
          sui-gap-x-4 
          sui-grid-cols-2
          sm:sui-grid-cols-3
          lg:sui-grid-cols-6
          lg:sui-gap-8
          lg:sui-px-8
        `}
      >
        {data.map(({ title, imageUrl, ctaUrl }) => (
          <ProRewardItem
            title={title}
            imageUrl={imageUrl}
            ctaUrl={ctaUrl}
          />
        ))}
      </div>
    </Card>
  );
};

ProDeskProRewards.displayName = 'ProDeskProRewards';
